// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { List, fromJS } from 'immutable'

// components
import WeightingItem from '@aytm/app/stats/page/sidebar/weighting/WeightingItem'

// styles
import style from '@aytm/app/stats/page/sidebar/weighting/styles/WeightingList.module.scss'

// <Component>
const WeightingList = ({ items, surveyData, disabled, onAdd, onUpdate, onRemove }) => {
  const traitsOptions = useMemo(() => {
    const traits = surveyData.traits.map(t => {
      return {
        value: String(t.id),
        text: t.title
      }
    })
    return fromJS(traits)
  }, [surveyData.traits])
  const questionOptions = useMemo(() => {
    const questions = surveyData.questions.map(q => {
      return {
        value: String(q.position),
        text: `${q.pre_type ? 'PQ' : 'Q'}${q.visual_position}: ${q.text}`
      }
    })
    return fromJS(questions)
  }, [surveyData.questions])
  const virtualOptions = useMemo(() => {
    const virtual = Object.keys(surveyData.virtual).map(key => {
      return {
        value: String(key),
        text: surveyData.virtual[key].text
      }
    })
    return fromJS(virtual)
  }, [surveyData.virtual])

  const options = useMemo(
    () => traitsOptions.concat(questionOptions).concat(virtualOptions).toJSON(),
    [traitsOptions, questionOptions, virtualOptions]
  )

  return (
    <div className={style.component}>
      {items.map((itemModel, itemIndex) => (
        <WeightingItem
          key={`item-${itemIndex}`}
          index={itemIndex}
          model={itemModel}
          options={options}
          surveyData={surveyData}
          disabled={disabled}
          onUpdate={onUpdate}
          onRemove={onRemove}
        />
      ))}
      <div className={`${style.row} p-fluid`}>
        <span className={style.add} onClick={() => onAdd()}>
          Add Dimension
        </span>
      </div>
    </div>
  )
}

WeightingList.propTypes = {
  items: PropTypes.instanceOf(List),
  surveyData: PropTypes.object,
  disabled: PropTypes.bool,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onRemove: PropTypes.func
}

WeightingList.displayName = 'WeightingList'

export default WeightingList
